import { channel, RegistrationNoType, SystemType, TitleType, Vehicle } from "@tm/models"
import { ReactText } from "react"
import { z } from "zod"
import { getBundleParams } from "../../../../utils"

export const getGlassMainSchema = (translateText: (key: ReactText) => string) =>
    z.object({
        processName: z.string({ required_error: translateText(37) }).min(1, translateText(37)),

        repairCoverage: z
            .string({ required_error: translateText(37) })
            .min(1, translateText(37))
            .refine((val) => ["More", "Complete", "OneStoneChip", "TwoStoneChips"].includes(val), {
                message: translateText(37),
            }),
    })

export const getGlassVehicleSchema = (t: (key: ReactText) => string, vehicle?: Vehicle, isGermanOrAustrianVehicle?: boolean) => {
    const { enableDATVinSearch, useAttachToWorktask } = getBundleParams()

    const [userContext] = channel("GLOBAL")
        .last(1, "USER/CONTEXT_LOADED")
        .map((x) => x.content.context)

    return z.object({
        mileage: z.number({ required_error: t(37) }),
        registrationNo: isGermanOrAustrianVehicle ? z.string().trim().min(1, t(37)) : z.string().optional(),
        initialRegistration: z.date({ required_error: t(289).replace("#1#", "8") }),
        plateNumber: z.string().trim().min(1, t(37)),
        vin: z
            .string()
            .trim()
            .refine(
                (val) => {
                    const isShort = val.length < 17
                    const isDATVinInvalid =
                        userContext?.system.systemType === SystemType.Next &&
                        useAttachToWorktask &&
                        enableDATVinSearch &&
                        (vehicle?.vin !== val || vehicle?.registrationTypeId !== RegistrationNoType.DatVin)
                    return !isShort && !isDATVinInvalid
                },
                (val) => ({
                    message: val.length < 17 ? t(289).replace("#1#", "17") : t(1881),
                })
            ),
    })
}

export const getGlassCustomerSchema = (t: (key: ReactText) => string, titleType?: TitleType) => {
    return z.object({
        titleType: z.nativeEnum(TitleType, { required_error: t(37) }),
        firstName: titleType === TitleType.Company ? z.string().optional() : z.string().trim().min(1, t(37)),
        lastName: titleType === TitleType.Company ? z.string().optional() : z.string().trim().min(1, t(37)),
        companyName: titleType === TitleType.Company ? z.string().trim().min(1, t(37)) : z.string().optional(),
        street: z.string().trim().min(1, t(37)),
        streetNo: z.string().trim().min(1, t(37)),
        zip: z.string().trim().min(1, t(37)),
        city: z.string().trim().min(1, t(37)),
        country: z.string().trim().min(1, t(37)),
    })
}
